import React from "react";
import { Button, Drawer, Box, Typography } from "@mui/material";

const CustomizedDrawer = ({ message, drawerOpen, closeDrawer, onCancel }) => {
    return (
        <>
            {/* <Button>{"Top"}</Button> */}
            <Drawer
                anchor={"top"}
                open={drawerOpen}
                // onClose={toggleDrawer("top", false)}
            >
                <Box
                    sx={{
                        width: "auto",
                        padding: "2rem",
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "3rem",
                        padddingLeft: "3rem",
                        backgroundColor: "#f5f4f2",
                        justifyContent: "center",
                        gap: 1,
                    }}
                    role="presentation"
                >
                    <Typography
                        sx={{ textAlign: "center", marginRight: "1rem" }}
                    >
                        {message}
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={closeDrawer}
                    >
                        Confirm
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                </Box>
            </Drawer>
        </>
    );
};

export default CustomizedDrawer;
